import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Typography, TypographyProps } from '@mui/material';

interface MarkdownTextProps extends Omit<TypographyProps, 'children'> {
  children?: string | null;
}

const toArray = (value: TypographyProps['sx']) => {
  if (!value) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
};

export const MarkdownText: React.FC<MarkdownTextProps> = ({
  children,
  sx,
  component = 'div',
  ...typographyProps
}) => {
  const content = children ?? '';

  return (
    <Typography
      {...typographyProps}
      component={component}
      sx={[
        {
          '& strong': { color: 'inherit', fontWeight: 600 },
          '& em': { color: 'inherit', fontStyle: 'italic' },
          '& p': { margin: 0 },
        },
        ...toArray(sx),
      ]}
    >
      <ReactMarkdown
        components={{
          p: ({ children: paragraphChildren }) => <span>{paragraphChildren}</span>,
          strong: ({ children: strongChildren }) => <strong>{strongChildren}</strong>,
          em: ({ children: emphasisChildren }) => <em>{emphasisChildren}</em>,
        }}
      >
        {content}
      </ReactMarkdown>
    </Typography>
  );
};
